import { useOutletContext } from "react-router-dom";
import { useClientPortalPaths } from "./useClientPortalBase";

export default function useMidpointMediaAdminView() {
  const { activeViewId, activeView, permissions } = useOutletContext() || {};
  const paths = useClientPortalPaths();
  return {
    clientViewId: activeViewId,
    activeView,
    permissions,
    paths,
    viewBase: activeViewId ? paths.view(activeViewId) : null,
  };
}
